import moment from 'moment';

export const isNormalExceeding = (dateDayFrom, dateMonthFrom, dateYearFrom, dateDayTo, dateMonthTo, dateYearTo) => {
    return ((dateDayFrom && dateMonthFrom && dateYearFrom)
              || (!dateDayFrom && dateMonthFrom && dateYearFrom)
              || (!dateDayFrom && !dateMonthFrom && dateYearFrom))
            && ((dateDayTo && dateMonthTo && dateYearTo)
                  || (!dateDayTo && dateMonthTo && dateYearTo)
                  || (!dateDayTo && !dateMonthTo && dateYearTo))
            && moment(`${dateYearTo}-${dateMonthTo}-${dateDayTo}`, "Y-MM-DD") < moment(`${dateYearFrom}-${dateMonthFrom}-${dateDayFrom}`, "Y-MM-DD");
};

export const isEqual = (dateDayFrom, dateMonthFrom, dateYearFrom, dateDayTo, dateMonthTo, dateYearTo) => {
    return ((dateYearTo === dateYearFrom) || (!dateYearTo && !dateYearFrom)) &&
            ((dateMonthTo === dateMonthFrom) || (!dateMonthTo && !dateMonthFrom)) &&
            ((dateDayTo === dateDayFrom) || (!dateDayTo && !dateDayFrom));
};

export const validate = (values) => {
    const errors = {};
    const dateFrom = values.from;
    const dateTo = values.to;
    const dateFromBc = values.fromBc;
    const dateToBc = values.toBc;

    if (!dateFrom || !dateTo) {
        errors._error = 'required';
        return errors;
    }

    const dateArrFrom = dateFrom.replace(/_/g, '').split('.').map(date => parseInt(date, 10));
    const dateArrTo = dateTo.replace(/_/g, '').split('.').map(date => parseInt(date, 10));

    const dateDayFrom = dateArrFrom[0];
    const dateMonthFrom = dateArrFrom[1];
    const dateYearFrom = dateArrFrom[2];

    const dateDayTo = dateArrTo[0];
    const dateMonthTo = dateArrTo[1];
    const dateYearTo = dateArrTo[2];

    // if ((!dateFrom && dateFromBc) || (!dateTo && dateToBc)) {
    //     errors._error = 'required_bc';
    //     return errors;
    // }

    const isNormalExceedingCurrent = isNormalExceeding(dateDayFrom, dateMonthFrom, dateYearFrom, dateDayTo, dateMonthTo, dateYearTo);
    const isEqualCurrent = isEqual(dateDayFrom, dateMonthFrom, dateYearFrom, dateDayTo, dateMonthTo, dateYearTo);

    if ((isNormalExceedingCurrent && !dateFromBc && !dateToBc)
        || (!isNormalExceedingCurrent && !isEqualCurrent && dateFromBc && dateToBc)
        || (!dateFromBc && dateToBc && dateFrom)) {
        errors._error = 'to_exceeds_from';
        return errors;
    }

    return errors;
};

export const isInRange = (date) => {

    if (date) {
        const dateArr = date.replace(/_/g, '').split('.').map(date => parseInt(date, 10));

        const dateDay = dateArr[0];
        const dateMonth = dateArr[1];
        const dateYear = dateArr[2];

        if (dateDay && dateMonth && dateYear && moment() < moment(`${dateYear}-${dateMonth}-${dateDay}`, "Y-MM-DD")) {
            return 'out_of_range';
        }

        if (moment().year() < dateYear) {
            return 'out_of_range';
        }

        if (moment().year() === dateYear && moment().month() + 1 < dateMonth) {
            return 'out_of_range';
        }
    }
};

export const isProperFormat = (date) => {
    if (date) {
        const dateArr = date.replace(/_/g, '').split('.').map(date => parseInt(date, 10));
        const dateDay = dateArr[0];
        const dateMonth = dateArr[1];
        const dateYear = dateArr[2];

        if ((dateDay && !dateMonth && dateYear)
              || (dateDay && !dateMonth && !dateYear)
              || (dateDay && dateMonth && !dateYear)
              || (!dateDay && dateMonth && !dateYear)) {
            return 'format';
        }

        if (!moment(`${dateYear}-${dateMonth}-${dateDay}`, "Y-MM-DD").isValid()) {
            return 'format';
        }
    }
};



// WEBPACK FOOTER //
// ./src/scripts/DateRangeValidation.js